<template>
    <div>
        <input v-if="!selectedAddress && !showManualEntry" ref="autocomplete" v-model="address" type="text" placeholder="Enter your address" :disabled="!isGoogleLoaded" class="text-field-7 new w-input" @blur="handleBlur" />
        <div v-if="selectedAddress || showManualEntry">
            <div class="address-split">
                <div class="address-div"><input class="rx_textfield w-input" v-model="manualEntry.street"  maxlength="256" name="Address-1" data-name="Address 1" placeholder="Address" type="text" id="Address-2" required></div>
                <div class="apt-div"><input class="rx_textfield w-input"  v-model="manualEntry.address_line2" maxlength="256" name="Apt-2" data-name="Apt 2" placeholder="Apt #" type="text" id="Apt-2"  @blur="onAddressChange"></div>
            </div>

            <div class="city-state-zip-div">
                <input  v-model="manualEntry.city"  class="rx_textfield _3rds w-input" maxlength="256" name="Address-1" data-name="Address 1" placeholder="City" type="text" id="Address-2" required  @input="onAddressChange">
                <input v-model="manualEntry.state" class="rx_textfield _3rds w-input" maxlength="256" name="Address-1" data-name="Address 1" placeholder="State" type="text" id="Address-2" required  @input="onAddressChange">
                <input v-model="manualEntry.zip" class="rx_textfield _3rds w-input" maxlength="256" name="Address-1" data-name="Address 1" placeholder="Zip" type="text" id="Address-2" required  @input="onAddressChange">
            </div>
            
        </div>
    </div>
    </template>
    
    <script>
    export default {
        name: 'GooglePlacesAutocomplete',
        props: {
            apiKey: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                address: '',
                autocomplete: null,
                selectedAddress: null,
                manualEntry: {
                    street: '',
                    city: '',
                    state: '',
                    zip: '',
                    address_line2: ''
                },
                isGoogleLoaded: false,
                showManualEntry: false
            }
        },
        watch: {
            selectedAddress: {
                handler(newVal) {
                    if (newVal) {
                        // Copy selected address to manual entry for editing
                        this.manualEntry = {
                            street: newVal.street,
                            city: newVal.city,
                            state: newVal.state,
                            zip: newVal.zip,
                            address_line2: newVal.address_line2 || ''
                        };
                    }
                },
                immediate: true
            }
        },
        mounted() {
            this.loadGoogleMapsAPI()
        },
        methods: {
            loadGoogleMapsAPI() {
                const script = document.createElement('script')
                script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places`
                script.async = true
                script.defer = true
                script.onload = () => {
                    this.isGoogleLoaded = true
                    this.initAutocomplete()
                }
                document.head.appendChild(script)
            },
            initAutocomplete() {
                if (!window.google) {
                    console.error('Google Maps API not loaded')
                    return
                }
                const options = {
                    types: ['address'],
                    componentRestrictions: {
                        country: 'us'
                    }
                }
                this.autocomplete = new window.google.maps.places.Autocomplete(
                    this.$refs.autocomplete,
                    options
                )
                this.autocomplete.addListener('place_changed', this.handlePlaceSelect)
            },
            handlePlaceSelect() {
                const place = this.autocomplete.getPlace()
                if (!place.geometry) {
                    console.log("No details available for input: '" + place.name + "'")
                    return
                }
    
                this.selectedAddress = {
                    street: '',
                    city: '',
                    state: '',
                    zip: '',
                    address_line2: ''
                }
    
                for (const component of place.address_components) {
                    const type = component.types[0]
                    if (type === 'street_number') {
                        this.selectedAddress.street = component.long_name + ' '
                    }
                    if (type === 'route') {
                        this.selectedAddress.street += component.long_name
                    }
                    if (type === 'locality') {
                        this.selectedAddress.city = component.long_name
                    }
                    if (type === 'administrative_area_level_1') {
                        this.selectedAddress.state = component.short_name
                    }
                    if (type === 'postal_code') {
                        this.selectedAddress.zip = component.long_name
                    }
                }
    
                // Attempt to extract address line 2
                const formattedAddress = place.formatted_address
                const parts = formattedAddress.split(',')
                if (parts.length > 1) {
                    const firstPart = parts[0].trim()
                    if (firstPart.includes(' ')) {
                        const potentialSubpremise = firstPart.split(' ').pop()
                        if (potentialSubpremise.match(/^\d+[a-zA-Z]?$|^[a-zA-Z]$/)) {
                            this.selectedAddress.address_line2 = potentialSubpremise
                            this.selectedAddress.street = this.selectedAddress.street.replace(potentialSubpremise, '').trim()
                        }
                    }
                }
    
                this.$emit('address-updated', this.selectedAddress)
            },
            handleBlur() {
                // Check if user entered something but didn't select from dropdown
                setTimeout(() => {
                    if (this.address && this.address.trim() !== '' && !this.selectedAddress) {
                        this.showManualEntry = true;
                        
                        // Try to parse the entered address to populate fields
                        const parts = this.address.split(',');
                        if (parts.length > 0) {
                            this.manualEntry.street = parts[0].trim();
                        }
                        
                        if (parts.length > 1) {
                            const cityPart = parts[1].trim();
                            this.manualEntry.city = cityPart;
                        }
    
                        if (parts.length > 2) {
                            const statePart = parts[2].trim();
                            // Try to extract state and zip if format is like "CA 90210"
                            const stateZipMatch = statePart.match(/([A-Z]{2})\s+(\d{5}(-\d{4})?)/);
                            if (stateZipMatch) {
                                this.manualEntry.state = stateZipMatch[1];
                                this.manualEntry.zip = stateZipMatch[2];
                            } else {
                                this.manualEntry.state = statePart;
                            }
                        }
                    }
                }, 200); // Small delay to allow for place selection to happen first
            },
            onAddressChange() {
                this.$emit('address-updated', this.manualEntry);
            },
            resetAddress() {
                this.selectedAddress = null;
                this.address = '';
                this.showManualEntry = false;
                this.manualEntry = {
                    street: '',
                    city: '',
                    state: '',
                    zip: '',
                    address_line2: ''
                };
                this.$nextTick(() => {
                    this.$refs.autocomplete.focus();
                });
            }
        }
    }
    </script>
    
    <style scoped>
    
    
    .manual-entry-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        font-size: 14px;
    }
    
    .manual-entry-header a {
        color: #337ab7;
        text-decoration: underline;
        cursor: pointer;
    }
    
    /* Custom styles for Google Places Autocomplete */
    .pac-container {
        font-family: 'Readex Pro', sans-serif;
        /* Replace with your site's font */
        border-radius: 4px;
        border: 1px solid #ccc;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    }
    
    .pac-item {
        padding: 8px;
        font-size: 14px;
        cursor: pointer;
    }
    
    .pac-item:hover {
        background-color: #f0f0f0;
    }
    
    .pac-icon {
        display: none;
        /* Hide the default icon if you prefer */
    }
    </style>